import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "map-container" }
const _hoisted_3 = { class: "input-groups" }
const _hoisted_4 = {
  class: "area-list",
  ref: "areaListRef"
}
const _hoisted_5 = { style: {"margin-right":"10px"} }

import { useStore } from '@/store/index'
import { useRoute } from 'vue-router'
import { reactive, ref, getCurrentInstance, computed, onMounted, nextTick } from 'vue'
import { getRuleInfoApi, saveMapApi, deliveryFeeRecallApi } from '../../apis/brand'
import { getRandomColor } from '../../utils/index'
import { Delete } from '@element-plus/icons-vue'

interface AreaI {
    id?: number,
    name: string, // 区域名称
    amount: number | string, // 运费
    o_shenhe_amount?: number | string, // 原目标运费
    shenhe_amount: number | string, // 目标运费
    free: number | string, // 免运费门槛
    clearing_amount: number | string, // 结算运费
    isMarker: boolean, // 是否为标注（可用于判断是否为新增区域，当值不为 undefined 时表示为新增）
    status?: number | string, // 运费审核状态
    rejection_msg?: string, // 驳回原因
    d_id?: number | string, // 审核 id，当运费审核状态为审核中时，会有此字段
    color: string,
    points?: any
    scrollToLeft?: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DistributionMap',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()
const route = useRoute()

const { city_id, brand_id, rule_id, city_name, o, item_type } = route.query // 地址栏参数
const isCollapse = computed(() => store.state.app.sidebar.opened) // 左右菜单栏是否收起
const mapHeight = computed(() => ((window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 230) + 'px') // 地图高度

// 区域接口
const areaList = ref<AreaI[]>([]) // 保存文字数据

// 获取地图数据
const getRuleInfo = async () => {
    const { code, data, msg } = await getRuleInfoApi(item_type, brand_id, city_id) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    if (data.ship_areas) {
        const ship_areas = JSON.parse(data.ship_areas)
        default_amount.value = ship_areas.default_amount || -1
        default_clearing_amount.value = ship_areas.default_clearing_amount || -1
        default_free.value = ship_areas.default_free || -1
        ship_areas.areas && renderAreas(ship_areas.areas)
    }
}
getRuleInfo()

// 默认地图中心点
// const defaultCenterPoint = reactive({
//     lng:    '116.403901',   // 经度
//     lat:    '39.916527',    // 纬度
// })

// 创建地图全局实例
let map:any = null
onMounted(() => {
    // 创建地图实例
    map = new BMapGL.Map('bMap')

    // 创建中心点和缩放比例
    map.centerAndZoom(city_name, 13)

    // 启动鼠标滚轮操作
    map.enableScrollWheelZoom()

    // 添加自动完成输入地址控制栏
    nextTick(() => {
        initAutocomplete() // 添加搜索联想功能
        initDrawTool() // 添加鼠标工具栏
    })
})

// 搜索联想内容
const suggestStr = ref('')
const suggestPoint = ref<any>({})
// 初始化搜索联想功能
const initAutocomplete = () => {
    let ac = new BMapGL.Autocomplete({
        "input": 'suggestId',
        "location": map
    })
    // 添加联想选中监听
    ac.addEventListener('onconfirm', function(e) {
        setPlace(e.item.value) // 识别当前地址并添加标注
    })
}
// 将地联想地址添加到地图同时调整视野
const setPlace = (val) => {
    let addr = val.province +  val.city +  val.district +  val.street + val.streetNumber +  val.business
    let local = new BMapGL.LocalSearch(map, {
        onSearchComplete: function () {
            let p = local.getResults().getPoi(0).point; // 获取第一个智能搜索的结果
            suggestPoint.value = p // 将搜索联想结果坐标保存，添加参照点时使用
            addMarker(p) // 添加搜索结果标注
        }
    })
    local.search(addr)
}

// 其他区域数据
const default_name = ref('其他区域')
const default_amount = ref(-1)
const default_clearing_amount = ref(-1)
const default_free = ref(-1)
const checkLimit = (val) => {
    if (val > 30) return proxy.$message({ type: 'error', message: '运费配置须小于等于30' })
}
// 判断如果是新增区域且目标运费大于0，则将运费置为-1，审核通过后生效
const checkNew = (index) => {
    let item = areaList.value[index]
    const { scrollToLeft, shenhe_amount } = item
    if (scrollToLeft && Number(shenhe_amount) > 0) {
        item.amount = -1
    }
}
const checkData = () => {
    let flag = true
    for (let i=0,len=areaList.value.length; i<len; i++) {
        let item = areaList.value[i]
        const { name, shenhe_amount, free } = item
        if (free === '') {
            proxy.$message({ type: 'error', message: `${name} 免运费值不能为空，请完善后再提交~` })
            flag = false
            break
        }
        if (Number(shenhe_amount) > 30) {
            proxy.$message({ type: 'error', message: `${name} 运费须小于等于30` })
            flag = false
            break
        }
    }
    return flag
}
const onSave = () => {
    if (checkData()) {
        let postData:any = {}
        
        areaList.value.map(item => {
            delete item.status
            delete item.rejection_msg
        })

        for (let i=0,len=areaList.value.length; i<len; i++) {
            let area = areaList.value[i]
            
            let overlay = overlays.value[i]
            area.points = area.isMarker ?  overlay.getPosition() : overlay.getPath()
        }
        
        postData.city_name = city_name
        postData.default_amount = default_amount.value
        postData.default_free = default_clearing_amount.value
        postData.default_free = default_free.value
        postData.areas = areaList.value
        
        saveMapApi({
            distribution_rule_id: rule_id,
            ship_areas: JSON.stringify(postData)
        }).then((res:any) => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: '保存成功' })
            // location.reload()
        })
    }
}

// 运费审核撤回
const onRecall = (d_id) => {
    proxy.$confirm('确定要撤回当前目标运费审核吗？', '提示', {
        type: 'warning'
    }).then(() => {
        deliveryFeeRecallApi(rule_id, d_id, 1).then((res:any) => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: '撤回成功' })
            setTimeout(() => {
                location.reload()
            }, 600)
        })
    }).catch(() => {
        console.log('取消运费审核')
    })
}

const overlays = ref<any[]>([]) // 保存图形覆盖物数据
// const markerArr = ref<any[]>([]) // 保存 mark 覆盖物数据
// markerArr.value.length = 100

const color = ref(getRandomColor())
let styleOptions = reactive({
    strokeColor:color,    //边线颜色。
    fillColor:color,      //填充颜色。当参数为空时，圆形将没有填充效果。
    strokeWeight: 2,       //边线的宽度，以像素为单位。
    strokeOpacity: 0.8,	   //边线透明度，取值范围0 - 1。
    fillOpacity: 0.3,      //填充的透明度，取值范围0 - 1。
    strokeStyle: 'solid' //边线的样式，solid或dashed。
})

const renderAreas = (areas) => {
    for(let i = 0; i < areas.length; i++) {
        let area = areas[i];
        const { name, amount, free, points, isMarker, shenhe_amount, status, rejection_msg, d_id } = area

        if (!points) continue // 没有地图点直接跳转至下一次循环
        let polygon:any = null
        if (points.length) {
            let arr = new Array()
            for (let j = 0; j < points.length; j++) {
                let p = points[j]
                arr.push(new BMapGL.Point(p['lng'], p['lat']))
            }
            polygon = new BMapGL.Polygon(arr, styleOptions)
            polygon.addEventListener('click', function (e) {
                showInfoWindow(e, i)
            })
            map.addOverlay(polygon)
        } else {
            let marker = new BMapGL.Marker(new BMapGL.Point(points.lng, points.lat))
            overlays[i] = marker
            map.addOverlay(marker)
        }
        addArea({overlay: polygon, name, amount, free, area, isMarker, shenhe_amount, status, rejection_msg, d_id})
    }
}

// 新增覆盖物和区域
// interface AddAreaI {
//     overlay: any, // 覆盖物对象
//     area: any, // 覆盖物坐标
//     name: string, // 区域名称
//     amount: number, // 运费
//     free: number, // 免运费门槛
//     isMarker: boolean, // 是否为标注点
//     shenhe_amount: number, // 目标运费
//     status?: number, // 审核状态
//     rejection_msg?: string // 审核驳回原因
// }
// overlay, name, amount, free, area, isMarker, shenhe_amount, status, rejection_msg, d_id, scrollToLeft = false
const addArea = (obj) => {
    // let index = overlays.value.length-1
    // let points_len = area.points.length || Object.keys(area.points).length
    // if (isMarker) {
    //     overlays[index] = overlay
    //     console.log(overlays[index])
    // }

    addDistribution({...obj, color: color.value})
    addOverlay(obj.overlay)

    // 为下一次画图更新颜色
    color.value = getRandomColor()
    styleOptions.strokeColor = color.value
    styleOptions.fillColor = color.value
    initDrawTool()
}

// 添加一个新的覆盖物记录
const addOverlay = (overlay) => {
    overlays.value.push(overlay)
}

// 添加一条新的区域描述记录
const addDistribution = (obj) => {
    const {name, amount, free, isMarker, color, shenhe_amount, status, rejection_msg, d_id, scrollToLeft} = obj
    areaList.value.push({
        d_id,
        name,
        amount,
        o_shenhe_amount: status == 2 ? shenhe_amount : '', // 当状态为驳回时，保存原目标运费
        shenhe_amount: status == 2 ? '' : shenhe_amount, // 当前 状态为驳回时，清空目标运费
        free,
        isMarker,
        status,
        color,
        clearing_amount: -1,
        rejection_msg,
        scrollToLeft,
    })

    // 新增一条，滚动至相应位置
    nextTick(() => {
        scrollToLeft && scrollToRight()
    })
}

// 横向滚动条滚动至最右侧
const scrollToRight = () => {
    const clientWidth = proxy.$refs['areaListRef'].clientWidth
    const scrollWidth = proxy.$refs['areaListRef'].scrollWidth
    proxy.$refs['areaListRef'].scrollLeft = (scrollWidth - clientWidth) + 10
}

const deleteArea = (index, name, isMarker, status) => {
    if (status === 0) return proxy.$message({ type: 'error', message: '当前记录目标运费正在审核中，请撤回审核或等待审核完成后再进行删除~' })
    proxy.$confirm(`确定要删除${name}吗？`, '提示', {
        type: 'warning'
    }).then(() => {
        // if (isMarker) {
        //     console.log(markerArr.value[index])
        //     map.removeOverlay(markerArr.value[index])
        // } else {
        //     console.log(overlays.value[index])
        //     map.removeOverlay(overlays.value[index])
        // }
        map.removeOverlay(overlays.value[index])
        areaList.value.splice(index, 1)
        // if (isMarker) {
        //     markerArr.value.splice(index, 1)
        // } else {
        //     overlays.value.splice(index, 1)
        // }
        overlays.value.splice(index, 1)
    }).catch(() => {
        console.log('取消删除')
    })
    // if (confirm(`确定要删除`)) {
    //     if (points_len === 2) {
    //         map.removeOverlay(markerArr[index])
    //     } else {
    //         map.removeOverlay(overlays[index]);
    //     }
    //     // $("#area" + index).remove();
    // }
}

//实例化鼠标绘制工具
const initDrawTool = () => {
    let drawingManager:any = {}

    drawingManager = new BMapGLLib.DrawingManager(map, {
        isOpen: true, // 是否开启绘制模式
        enableDrawingTool: true, // 是否显示工具栏
        drawingToolOptions: {
            anchor: BMAP_ANCHOR_TOP_RIGHT, // 位置
            offset: new BMapGL.Size(5, 5), // 偏离值
            scale: 0.8, // 工具栏缩放比例
            drawingTypes : [
                'circle',
                'rectangle',
                'polygon'
            ]
        },
        circleOptions: styleOptions, // 圆的样式
        polylineOptions: styleOptions, // 线的样式
        polygonOptions: styleOptions, // 多边形的样式
        rectangleOptions: styleOptions // 矩形的样式
    })
    drawingManager.addEventListener('overlaycomplete', function(e) {
        if (e.drawingMode === 'marker') {
            map.removeOverlay(e.overlay)
            return
        }

        e.overlay.drawingMode = e.drawingMode // 覆盖物图形
        let area = { points: [] }
        if (e.overlay.drawingMode !== 'marker') {
            area.points.length = 1
        }

        let name = "区域" + (overlays.value.length + 1)
        let amount = 0
        let free = -1

        addArea({
            overlay: e.overlay,
            isMarker: e.overlay.drawingMode == 'marker',
            shenhe_amount: '',
            status: '',
            rejection_msg: '',
            d_id: (new Date()).getTime(),
            scrollToLeft: true,
            name, amount, free, area
        })
    })
}

// 显示弹框信息
const showInfoWindow = (e, i) => {
    let area = areaList.value[i]
    let name = area['name']
    let amount = area['amount']
    let clearing_amount = area['clearing_amount']
    if (!clearing_amount) {
        clearing_amount = amount
    }
    let free = area['free']
    let sContent = '<div style="font-weight:bold;color:#666;font-size:12px;">区域名称：' + name + '</div>'
        sContent += '<div style="margin-top:5px;color:#666;font-size:12px;">运费(元)：' + amount + '</div>'
        sContent += '<div style="margin-top:5px;color:#666;font-size:12px;">订单满'+free+'元免运费</div>'
    let infoWindow = new BMapGL.InfoWindow(sContent)
    map.openInfoWindow(infoWindow, e.latLng)
}

// 添加标注点
const addMarker = (p, name) => {
    let point = new BMapGL.Point(p.lng, p.lat) // 转换为百度地图坐标
    let marker = new BMapGL.Marker(point) // 创建标注实例

    // map.clearOverlays() // 清除其他覆盖物
    marker.name = name // 添加 name 属性，删除时使用
    map.addOverlay(marker) // 添加标注
    map.centerAndZoom(point, 16) // 设置中心点及缩放比例
    // marker.enableDragging() // 标注点可拖动

    // 添加标注点拖动监听
    // marker.addEventListener('dragend', function(e) {
    //     setDomValue(e.point)
    // })
}

// 参照点
const referDistance = ref<number | string>('')
// 添加东南西北四个辅助点
const addGuidMarker = () => {
    let lng = suggestPoint.value.lng,
        lat = suggestPoint.value.lat
    if (!lng || !lat) {
        return proxy.$message({ type: 'error', message: '请先输入地址' })
    }
    if (!referDistance.value) {
        return proxy.$message({ type: 'error', message: '请输入参照点距离' })
    }
    let distance = Number(referDistance.value)
    addMarker(getNewPoint(lng, lat, distance, 0), 'guid')
    addMarker(getNewPoint(lng, lat, distance, 90), 'guid')
    addMarker(getNewPoint(lng, lat, distance, 180), 'guid')
    addMarker(getNewPoint(lng, lat, distance, 270), 'guid')
}

// 清除标注点
const clearGuidMarker = () => {
    let allOverlay = map.getOverlays()
    for (let i=0,len=allOverlay.length; i<len; i++) {
        if (allOverlay[i].name === 'guid') {
            map.removeOverlay(allOverlay[i])
        }
    }
}

/**
 *  根据传入的经纬度返回指定距离和角度的经纬度
 * 入参：116.30724, 39.951215, 500, 90，返回以 116.30724, 39.951215 为原点，向90度角方向延伸500米距离的经纬度，即正东500米
 */
const getNewPoint = (lng, lat, dist, angle) => {
    const R = 6371 * 1000 // 地球半径 6371KM
    const distInMeters = dist * 1000
    let lng2 =(180 * distInMeters * Math.cos(radians(angle)) / (R * Math.PI * Math.cos(radians(lat))) + lng)
    let lat2 = (180 * distInMeters * Math.sin(radians(angle)) / (R * Math.PI) + lat)

    return {
        lng: lng2,
        lat: lat2
    }
}

// 将角度转换为弧度
const radians = (angle) => {
    return angle * Math.PI / 180
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        id: "bMap",
        style: _normalizeStyle({'width':'100%', 'height': mapHeight.value })
      }, null, 4),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          class: "suggest-input",
          id: "suggestId",
          modelValue: suggestStr.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((suggestStr).value = $event)),
          modelModifiers: { trim: true },
          placeholder: "搜索地点/关键字"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_input, {
          class: "refer-input ml20",
          modelValue: referDistance.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((referDistance).value = $event)),
          modelModifiers: { trim: true },
          placeholder: "参照点距离"
        }, {
          append: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("km")
          ])),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: addGuidMarker,
          class: "ml10"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("添加参照")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: clearGuidMarker
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("清除参照")
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", {
      class: "area-box",
      style: _normalizeStyle({ 'left': isCollapse.value ? '160px' : '54px' })
    }, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "msg-box" }, [
        _createElementVNode("div", null, [
          _createElementVNode("em", null, "说明："),
          _createTextVNode("1、运费为-1表示不可配送，0表示免费配送  2、免运费门槛设置成-1表示不能免费配送  3、目标运费大于0时，需审核通过后生效  4、有重叠区域，请先画比较大的区域（例如北京先画5环，再画4环）")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areaList.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_card, { class: "box-card" }, {
            header: _withCtx(() => [
              _createElementVNode("div", {
                class: "card-header",
                style: _normalizeStyle({'background': item.color})
              }, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(`区域${index+1}`), 1),
                _createVNode(_component_el_button, {
                  class: "button del-btn",
                  type: "info",
                  size: "small",
                  icon: _unref(Delete),
                  circle: "",
                  onClick: ($event: any) => (deleteArea(index, item.name, item.isMarker, item.status))
                }, null, 8, ["icon", "onClick"])
              ], 4)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _cache[5] || (_cache[5] = _createTextVNode(" 名称   ")),
                      _createVNode(_component_el_input, {
                        modelValue: item.name,
                        "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                        modelModifiers: { trim: true },
                        size: "small",
                        style: {"width":"120px"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _cache[7] || (_cache[7] = _createElementVNode("span", null, "满 ", -1)),
                      _createVNode(_component_el_input, {
                        modelValue: item.free,
                        "onUpdate:modelValue": ($event: any) => ((item.free) = $event),
                        modelModifiers: { trim: true },
                        size: "small",
                        onInput: ($event: any) => (item.free = item.free.toString().replace(/[^0-9.-]/g,''))
                      }, {
                        append: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("元")
                        ])),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "onInput"]),
                      _cache[8] || (_cache[8] = _createElementVNode("span", null, " 免运费", -1))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _cache[10] || (_cache[10] = _createTextVNode(" 当前运费   ")),
                      _createVNode(_component_el_input, {
                        modelValue: item.amount,
                        "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                        modelModifiers: { trim: true },
                        size: "small",
                        disabled: ""
                      }, {
                        append: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("元")
                        ])),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _cache[12] || (_cache[12] = _createTextVNode(" 目标运费   ")),
                      _createVNode(_component_el_input, {
                        modelValue: item.shenhe_amount,
                        "onUpdate:modelValue": ($event: any) => ((item.shenhe_amount) = $event),
                        modelModifiers: { trim: true },
                        disabled: item.status === 0  || _unref(item_type) !== 'city',
                        size: "small",
                        onInput: ($event: any) => (item.shenhe_amount = item.shenhe_amount.toString().replace(/[^0-9.-]/g,'')),
                        onBlur: ($event: any) => {checkLimit(item.shenhe_amount);checkNew(index)}
                      }, {
                        append: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode("元")
                        ])),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "onInput", "onBlur"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([item.status == 2 ? 'danger' : '']),
                    style: {"width":"100%","white-space":"normal"}
                  }, " 运费审核状态：" + _toDisplayString(item.status === 0 ? '待审核' : item.status == 2 ? `驳回（目标运费为 ${item.o_shenhe_amount} 元），${item.rejection_msg}` : '--'), 3),
                  (_unref(o) !== 'edit' && item.status === 0 && _unref(o) !== 'check')
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        size: "small",
                        style: {"margin-left":"10px"},
                        onClick: ($event: any) => (onRecall(item.d_id))
                      }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode("撤回")
                        ])),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 256))
      ], 512),
      (_unref(o) !== 'edit' && _unref(o) !== 'check')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "submit-btn",
            type: "danger",
            onClick: onSave
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("保存")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}
}

})